import { fmtBRL, fmtNum } from "@/lib/medicoes";

const calc = (p, q) => {
  const qtd = parseFloat(q) || 0;
  const acum = p.quantidade_anterior + qtd;
  return {
    qtd, acum, saldo: p.saldo_quantidade - qtd,
    valor: Math.round(qtd * p.valor_unitario * 100) / 100,
    valorAcum: Math.round(acum * p.valor_unitario * 100) / 100,
    pct: p.quantidade_contratada ? (acum / p.quantidade_contratada) * 100 : 0,
  };
};

function ItemCard({ p, value, obs, onChange, onObs, readOnly }) {
  const r = calc(p, value);
  const excede = r.saldo < -1e-6;
  return (
    <div data-testid={`med-item-${p.numero_item}`}
         className={`rounded-lg border p-4 ${excede ? "border-[#EF4444] bg-[#EF4444]/5" : "border-[#334155] bg-[#0F172A]/40"}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] font-mono text-[#94A3B8]">Item {p.numero_item} · Cód. {p.codigo}</div>
          <div className="text-sm font-medium mt-0.5">{p.descricao}</div>
          <div className="text-[11px] text-[#94A3B8] mt-1">
            Contratado {fmtNum(p.quantidade_contratada, 4)} {p.unidade_medida} · PU {fmtBRL(p.valor_unitario)}
          </div>
        </div>
        <div className="w-40">
          <label className="uppercase-label !text-[10px] block mb-1">Executado no período ({p.unidade_medida})</label>
          <input data-testid={`med-item-qtd-${p.numero_item}`} type="number" inputMode="decimal" step="any" min="0"
                 disabled={readOnly} value={value ?? ""} onChange={(e) => onChange(e.target.value)}
                 className={`tce-input w-full px-3 py-2.5 rounded-md text-base font-mono ${excede ? "!border-[#EF4444]" : ""}`} />
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2 mt-3 text-[11px]">
        {[
          ["Anterior aprovado", fmtNum(p.quantidade_anterior, 4)],
          ["Em trâmite (outras)", fmtNum(p.quantidade_em_tramite, 4)],
          ["Acumulado após", fmtNum(r.acum, 4)],
          ["Saldo do item", fmtNum(r.saldo, 4), excede ? "#EF4444" : undefined],
          ["Valor no período", fmtBRL(r.valor), "#FFDF00"],
          ["Valor acumulado", fmtBRL(r.valorAcum)],
          ["% execução", `${fmtNum(r.pct, 2)}%`],
        ].map(([l, v, c]) => (
          <div key={l} className="rounded bg-[#1E293B]/70 px-2 py-1.5">
            <div className="text-[#64748B]">{l}</div>
            <div className="font-mono" style={c ? { color: c } : undefined}>{v}</div>
          </div>
        ))}
      </div>
      {excede && <div data-testid={`med-item-alerta-${p.numero_item}`} className="text-xs text-[#EF4444] mt-2">Quantidade excede o saldo quantitativo autorizado do item.</div>}
      {(!readOnly || obs) && (
        <input data-testid={`med-item-obs-${p.numero_item}`} disabled={readOnly} value={obs || ""}
               onChange={(e) => onObs(e.target.value)} placeholder="Observação técnica do item (opcional)"
               className="tce-input w-full px-3 py-2 rounded-md text-xs mt-3" />
      )}
    </div>
  );
}

export const totalMedicao = (planilha, valores) =>
  planilha.reduce((s, p) => s + calc(p, valores[p.numero_item]?.q).valor, 0);

export default function ItensMedicao({ planilha, valores, setValores, readOnly, filtro = "" }) {
  const set = (n, k, v) => setValores((s) => ({ ...s, [n]: { ...(s[n] || {}), [k]: v } }));
  const lista = planilha.filter((p) => !filtro || `${p.numero_item} ${p.descricao} ${p.codigo}`.toLowerCase().includes(filtro.toLowerCase()))
    .filter((p) => !readOnly || parseFloat(valores[p.numero_item]?.q) > 0);
  if (!lista.length) return <p className="text-sm text-[#94A3B8]">Nenhum item.</p>;
  return (
    <div className="space-y-3">
      {lista.map((p) => (
        <ItemCard key={p.numero_item} p={p} readOnly={readOnly}
                  value={valores[p.numero_item]?.q} obs={valores[p.numero_item]?.obs}
                  onChange={(v) => set(p.numero_item, "q", v)} onObs={(v) => set(p.numero_item, "obs", v)} />
      ))}
    </div>
  );
}
